<template>
  
    <!-- 地图容器 -->
    <div 
      ref="mapContainer" 
      class="map-container"
      @click="onMapClick"
    ></div>
    

</template>

<script>
import {wgs84ToBd09} from './geo_conversion'
let currentInfoWindow  = null;
let currentOverlay = null;
// let icon = require('../../static/images/lo.png');
// let star_icon = require('../../static/images/start_level.png');
export default {
  name: 'baidu-map',
  
  props: {
    // 地图高度（像素）
    mapHeight: {
      type: Number,
      default: 500
    },
    // 默认中心点经度
    centerLng: {
      type: Number,
      default: 116.404
    },
    // 默认中心点纬度
    centerLat: {
      type: Number,
      default: 39.915
    },
    // 默认缩放级别
    zoomLevel: {
      type: Number,
      default: 15
    },
    // 是否启用倾斜和旋转
    enableTiltAndRotate: {
      type: Boolean,
      default: false
    },
    // 是否显示3D建筑
    show3DBuildings: {
      type: Boolean,
      default: true
    },
    mapData: {
        type: Array,
        default(){
        return [];
        },
    },
    isUnitHotel: {
        type: Boolean,
        default: false,
    },

  },
  
  data() {
    return {
      loading: true,           // 加载状态
      loadError: false,        // 加载错误
      mapInstance: null,       // 地图实例
      BMapGL: null,            // 地图API
      retryCount: 0,           // 重试次数
      maxRetries: 3,           // 最大重试次数
      mapLoaded: false,        // 地图是否已加载
      marker: null,            // 标记点
      defaultPoint: null,       // 默认中心点
      ak:'12U0g3N0svovq18DIFLLHy8u'
    };
  },
  
  mounted() {
    this.initMap();
  },
  
  beforeDestroy() {
    // 组件销毁前清理地图
    this.destroyMap();
  },
  
  methods: {
    // 初始化地图
    async initMap() {
      this.loading = true;
      this.loadError = false;
      
      try {
        // 加载百度地图API
        await this.loadBMapAPI();
        
        // 确保地图容器存在
        if (!this.$refs.mapContainer) {
          throw new Error('地图容器不存在');
        }
        console.log(this.mapData)
        const len = this.mapData.length;
        const centerData = this.mapData[Math.floor(len / 2)];
        const bd09 = wgs84ToBd09(Number(centerData.longitude),Number(centerData.latitude));
        
        // 创建地图实例
        this.createMap(bd09);
        if(len > 0){
            if(this.isUnitHotel){
                this.renderMarkerIcon(bd09)
            }else{
                this.renderPriceMarker()
            }
        }
        
        // 触发加载完成事件
        // this.$emit('map-loaded', this.mapInstance);
        
      } catch (error) {
        console.error('地图初始化失败:', error);
        this.handleLoadError(error);
      }
    },
    
    // 加载百度地图API
    loadBMapAPI() {
      return new Promise((resolve, reject) => {
        // 如果已加载，直接返回
        if (window.BMapGL) {
          this.BMapGL = window.BMapGL;
          resolve();
          return;
        }
        
        // 定义全局回调函数
        window.onBMapGLScriptLoad = () => {
          if (window.BMapGL) {
            this.BMapGL = window.BMapGL;
            resolve();
          } else {
            reject(new Error('BMapGL未定义'));
          }
          // 清理回调
          delete window.onBMapGLScriptLoad;
        };
        
        // 创建script标签
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = `https://api.map.baidu.com/api?v=3.0&ak=${this.ak}&type=webgl&callback=onBMapGLScriptLoad`;
        
        script.onerror = () => {
          reject(new Error('加载百度地图API失败'));
          delete window.onBMapGLScriptLoad;
        };
        
        // 设置超时
        const timeoutId = setTimeout(() => {
          reject(new Error('加载百度地图API超时'));
          delete window.onBMapGLScriptLoad;
          document.head.removeChild(script);
        }, 10000);
        
        script.onload = () => {
          clearTimeout(timeoutId);
        };
        
        // 添加到文档
        document.head.appendChild(script);
      });
    },
    
    // 创建地图实例
    createMap(bd09) {
      const BMapGL = this.BMapGL;
      const point = new BMapGL.Point(bd09[0],bd09[1])
      // 创建默认点
    //   this.defaultPoint = new BMapGL.Point(this.centerLng, this.centerLat);
      
      // 创建地图实例
      this.mapInstance = new BMapGL.Map(this.$refs.mapContainer, {
        minZoom: 3,        // 最小缩放级别
        maxZoom: 19,       // 最大缩放级别
        enableAutoResize: true,  // 自动调整大小
      });
      
      // 设置中心点和缩放级别
      this.mapInstance.centerAndZoom(point, this.zoomLevel);
      
      // 启用滚轮缩放
      this.mapInstance.enableScrollWheelZoom(true);
      this.mapInstance.enableDoubleClickZoom(true);
      
    },
    renderMarkerIcon(bd09){
        const BMapGL = this.BMapGL;
        const point = new BMapGL.Point(bd09[0],bd09[1])
        
        var marker1 = new BMapGL.Marker(point);
        this.mapInstance.addOverlay(marker1)
    },
    renderPriceMarker(){
        const BMapGL = this.BMapGL;
        for(let [index,item] of this.mapData.entries()){
            const bd09 = wgs84ToBd09(Number(item.longitude),Number(item.latitude));
            let center =  new BMapGL.Point(bd09[0],bd09[1])
            var customOverlay = new this.BMapGL.CustomOverlay(this.renderDom, {
                point: center,
                opacity: 0.5,
                offsetY: -10,
                properties: {
                    item:item,index:index,center:center
                }
            });
            this.mapInstance.addOverlay(customOverlay);
        }
    },
    renderDom(e){
        let _this = this;
        const BMapGL = this.BMapGL;
        let item = e.item
        let index = e.index
        let center = e.center
        console.log(e)
        var div = document.createElement('div');
        div.style.height = '56px';
        div.style.width = '110px';
        div.style.display = 'flex';
        div.style.justifyContent = 'center';
        div.style.alignItems = 'center';

        div.style.fontSize = '12px';
        var div1 = document.createElement('div');
        let price = parseInt(item.min_price.price) || 0
        if(price>0){
            div1.classList.add('zIndex')
        }
        div1.classList.add('chat-bubble-white')
        
        
        var title = document.createElement('div');
        title.classList.add('chat-name')
        let abbr1 = item.hotel_name.toString().length>10?item.hotel_name.substr(0,10)+'...':item.hotel_name
        title.appendChild(document.createTextNode(abbr1));
        var priceDiv = document.createElement('div');
        priceDiv.classList.add('price-text')
        if(price>0){
            priceDiv.appendChild(document.createTextNode(`${item.min_price.currency_code} ${price}`));
        }
        
        
        div1.appendChild(title);
        div1.appendChild(priceDiv);
        div.appendChild(div1);
        div.onmouseenter = function() {
            // let content = 'sdsds'
            // const BMapGL = this.BMapGL;
            
            // currentInfoWindow = new BMapGL.InfoWindow(content, {
            //     width: 250,
            //     height: 100,
            //     title: '信息'
            // });
            // _this.mapInstance.openInfoWindow(currentInfoWindow, center);
            // this.mapInstance.openInfoWindow(infoWindow, center);
            if (currentInfoWindow && currentOverlay !== this) {
                _this.mapInstance.closeInfoWindow();
            }
            currentOverlay = this;
            let html = _this.returnHtml(item);
            const infoWindowDom = document.createElement('div');
            infoWindowDom.className = 'custom-info-window';
            infoWindowDom.innerHTML = html;
            infoWindowDom.style.cssText = `
                position: absolute;
                background: white;
                padding: 10px;
                border-radius: 5px;
                box-shadow: 0 2px 6px rgba(0,0,0,0.3);
                pointer-events: auto;
                z-index:99999;
            `;
            infoWindowDom.dataset.id = item.hotel_id
            infoWindowDom.addEventListener('mouseenter', () => {
                clearTimeout(window.infoWindowTimer);
            });
            infoWindowDom.addEventListener('mouseleave', () => {
                window.infoWindowTimer = setTimeout(() => {
                    if (infoWindowDom.parentNode) {
                        infoWindowDom.parentNode.removeChild(infoWindowDom);
                        currentInfoWindow = null;
                    }
                }, 300);
            });
            
            const pixel = _this.mapInstance.pointToOverlayPixel(center);
            infoWindowDom.style.left = (pixel.x - 100) + 'px'; // 调整位置
            infoWindowDom.style.top = (pixel.y - 180) + 'px';
            _this.mapInstance.getContainer().appendChild(infoWindowDom);
            currentInfoWindow = infoWindowDom;
            div1.style.zIndex = '';
            div1.classList.add('zIndex');
            div1.classList.remove('chat-bubble-white');
            div1.classList.add('chat-bubble');
        }
        div.onmouseleave = function () {
            div1.classList.remove('zIndex');
            window.infoWindowTimer = setTimeout(() => {
                if (currentInfoWindow && currentInfoWindow.parentNode) {
                    currentInfoWindow.parentNode.removeChild(currentInfoWindow);
                    currentInfoWindow = null;
                    // $('.custom-info-window').remove();
                }
                
                
                
                currentOverlay = null;
                
            }, 200);

            div1.classList.remove('chat-bubble');
            div1.classList.add('chat-bubble-white');
        }
        div.onclick = function (){
            //清除上一个选中样式
            let zIndexDom =  document.querySelector('.zIndex')
            let chatDom1 =  document.querySelector('.chat-bubble')
            if(zIndexDom){
                zIndexDom.classList.remove('zIndex')
            }
            if(chatDom1){
                chatDom1.classList.remove('chat-bubble')
                chatDom1.classList.add('chat-bubble-white')
            }
            div1.style.zIndex = ''
            div1.classList.add('zIndex');
            div1.classList.add('chat-bubble')
            div1.classList.remove('chat-bubble-white')
            _this.$emit('on-data-index',index)
            
            let obj = {
                hotel_id: item.hotel_id
            };

            _this.$emit('on-link', obj)
        }
        return div
    },
    onMapClick(event) {
        console.log(event)
        let _this = this;
        const isClickOnInfoWindow = event.target.closest('.custom-info-window')
        
        
        if (isClickOnInfoWindow) {
            // this.closeAllInfoWindows()
            let obj = {
                hotel_id: isClickOnInfoWindow.dataset.id
            };

            _this.$emit('on-link', obj)
        }
        
    },
    // 添加默认标记点
    addDefaultMarker() {
      const BMapGL = this.BMapGL;
      
      // 创建标记点
      this.marker = new BMapGL.Marker(this.defaultPoint);
      
      // 添加标记点
      this.mapInstance.addOverlay(this.marker);
      
      // 添加信息窗口
      const infoWindow = new BMapGL.InfoWindow('北京市', {
        width: 200,
        height: 40,
        title: '位置信息'
      });
      
      // 标记点点击事件
      this.marker.addEventListener('click', () => {
        this.mapInstance.openInfoWindow(infoWindow, this.defaultPoint);
        this.$emit('marker-click', {
          lng: this.defaultPoint.lng,
          lat: this.defaultPoint.lat
        });
      });
    },
    
    // 添加地图控件
    addMapControls() {
      const BMapGL = this.BMapGL;
      
      // 添加比例尺控件
      const scaleCtrl = new BMapGL.ScaleControl();
      this.mapInstance.addControl(scaleCtrl);
      
      // 添加缩放控件
      const zoomCtrl = new BMapGL.ZoomControl();
      this.mapInstance.addControl(zoomCtrl);
      
      // 添加版权控件
      const copyrightCtrl = new BMapGL.CopyrightControl();
      this.mapInstance.addControl(copyrightCtrl);
      
      // 添加定位控件（需要HTTPS）
      if (window.location.protocol === 'https:') {
        const locationCtrl = new BMapGL.LocationControl({
          anchor: window.BMAP_ANCHOR_BOTTOM_RIGHT,
          offset: new BMapGL.Size(10, 30)
        });
        this.mapInstance.addControl(locationCtrl);
      }
    },
    returnHtml(item){
        console.log(item)
        let $html = `
               <div class="hotel-info-box" style="cursor: pointer;" data-hotel-id="${item.hotel_id}">
                  <div class="img-wrapper inline-block">
                    <img src="${item.img_url?item.img_url:'https://cdn.jalan.jp/jalan/images/pict2L/Y0/Y303560/Y303560045.jpg'}" alt="">
                  </div>
                  <div class="info-content inline-block">
                    <div class="hotel-name">${item.hotel_name}</div>
                    <div class="hotel_name_en">${item.hotel_name_en}</div>
                    
                    <div class="star-wrapper">`;

        let star_icon = '/static/images/start_level.png';

        for (var j = 0, starNum = Number(item.star_rating); j < starNum; j++) {
          $html+= `<img src="${star_icon}" alt="">`
        }

        $html+= `</div>`;
        // $html += `<div >B.C.C减CNY 367起</div>`
        // $html += '<div >'+this.$t('hotel.TAXES_INCL')+' 7941 '+this.$t('hotel.ABOVE')+'</div>'
        if(item.min_price.price){
          $html += `<div class="bccDisCount"><img src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAOCAYAAAAbvf3sAAAB40lEQVQoU11ST0jUQRh987OWNSnc/EMtSBBFUOFC2628dvNUUHdPbYc6CJGE/PAgHbwIKpUIEdQl8JAHIYTokEUlJCTlSsRKtLFK64prO/P75vtk5rcbrXOZGea9ee9736ewb20tPctatoNMBiAz1tWXW/ofohqX7U/POyOFUbZmQMgETBpCmiWqzcDQULo/3HRYJRIG5eWzObbRiJBJOWAdXN8N2OqyWD18Yjk1pf58fjHBVLvlLEgdHBxIejBVN8CRdgRI/D6pNj8+1Uw6Ef9qPDDZfQZiI1TXP3iC2FiVyRhVWnws7nL4ZB8qq69g9Q6OZq5B2GLj/bRzjVTmKkpvH3oHqvhmXNwh0d6D1mPn8Pf3Cjou3PBZlN5N41C6F5W119j5segdqF8LD7yCMCF95T6ClkRT0K62tSfXwaYaK/ycD2MCaXRfuolk16kmwm5xBYXZ23Fi1kAVXt7VYk3CFdd6/DwOtnV4NVeDWIIpF1DJLzSKN2p99s4ERS5WjbaeLFqSRzwBjsAWZruIrS9zXgFiJ5WEYfD9dCEnVBth0r5xjX44C3Gspgym4Qzlp/6Nxuqj/k5WPCqmNsCkA0cSq1lsNBMZO3QxzMejsX/4vo5fzlKkB113FZux3nvfmoZvD/vxZx4pa0b+AAAAAElFTkSuQmCC' />B.C.C减${item.min_price.currency_code} ${item.bcc_discount_amount}${this.$t('hotel.ABOVE')}</div>
          <div class="totalPrice">
            ${item.tax_fee==0?this.$t('hotel.TAXES_INCL'):''}
            ${item.min_price.currency_code}<span style="font-size:18px;font-weight:700;"> ${parseInt(item.min_price.price)}</span>${this.$t('hotel.ABOVE')}`
          if(item.tax_fee>0){
            $html =+  `<div>${this.$t('hotel.Additional_Tax')}${item.min_price.currency_code} ${item.tax_fee}</div>
            `
          }    
        }else{
          $html +=`<div style="text-align: right;font-size: 16px;font-weight: 600;">${this.$t('hotel.PHONE_ASK')}</div>`
        }
        $html +='</div>'  
        if (item.score && item.score > 0) {
          $html +=
            `<div class="hotel-score-wrapper">
                     <div class="hotel-score">
                      <div class="score">${item.score}</div>
                    </div>`;
        }
        $html+= `</div></div>`;

        return $html;
    },
    // 设置地图样式（可选）
    setMapStyle() {
      // 这里可以自定义地图样式
      // 例如：https://lbsyun.baidu.com/index.php?title=jspopularGL/guide/mapstyle
    },
    
    // 处理加载错误
    handleLoadError(error) {
      this.loading = false;
      this.loadError = true;
      
      // 如果重试次数未达到上限，可以自动重试
      if (this.retryCount < this.maxRetries) {
        this.retryCount++;
        console.log(`地图加载失败，第${this.retryCount}次重试...`);
        
        // 延迟重试
        setTimeout(() => {
          this.retryLoad();
        }, 2000 * this.retryCount);
      }
      
      this.$emit('map-load-error', error);
    },
    
    // 重试加载
    retryLoad() {
      this.retryCount = 0;
      this.initMap();
    },
    
    // 放大
    zoomIn() {
      if (this.mapInstance) {
        this.mapInstance.zoomIn();
      }
    },
    
    // 缩小
    zoomOut() {
      if (this.mapInstance) {
        this.mapInstance.zoomOut();
      }
    },
    
    // 重置视图
    resetView() {
      if (this.mapInstance && this.defaultPoint) {
        this.mapInstance.centerAndZoom(this.defaultPoint, this.zoomLevel);
        if (this.enableTiltAndRotate) {
          this.mapInstance.setTilt(45);
        }
      }
    },
    
    // 设置地图中心点
    setCenter(lng, lat) {
      if (this.mapInstance) {
        const point = new this.BMapGL.Point(lng, lat);
        this.mapInstance.panTo(point);
        this.$emit('center-changed', { lng, lat });
      }
    },
    
    // 添加标记点
    addMarker(lng, lat, title = '') {
      if (!this.mapInstance || !this.BMapGL) return null;
      
      const point = new this.BMapGL.Point(lng, lat);
      const marker = new this.BMapGL.Marker(point);
      
      // 如果有标题，添加点击事件
      if (title) {
        const infoWindow = new this.BMapGL.InfoWindow(title, {
          width: 200,
          height: 40
        });
        
        marker.addEventListener('click', () => {
          this.mapInstance.openInfoWindow(infoWindow, point);
        });
      }
      
      this.mapInstance.addOverlay(marker);
      return marker;
    },
    
    // 清除所有标记点
    clearMarkers() {
      if (this.mapInstance) {
        this.mapInstance.clearOverlays();
      }
    },
    
    // 销毁地图
    destroyMap() {
      if (this.mapInstance) {
        this.mapInstance.destroy();
        this.mapInstance = null;
      }
      
      // 清理全局回调
      delete window.onBMapGLScriptLoad;
    }
  },
  
  watch: {
    // 监听地图高度变化
    mapHeight(newHeight) {
      if (this.mapInstance) {
        // 触发地图resize
        setTimeout(() => {
          if (this.mapInstance) {
            this.mapInstance.checkResize();
          }
        }, 100);
      }
    },
    
    // 监听中心点变化
    centerLng(newVal, oldVal) {
      if (newVal !== oldVal && this.mapInstance) {
        this.setCenter(newVal, this.centerLat);
      }
    },
    
    centerLat(newVal, oldVal) {
      if (newVal !== oldVal && this.mapInstance) {
        this.setCenter(this.centerLng, newVal);
      }
    }
  }
};
</script>

<style scoped>
.baidu-map-container {
  position: relative;
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.map-container {
  width: 100%;
  height: 100%;
}

.loading-mask,
.error-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.9);
  z-index: 1000;
}

.loading-content,
.error-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 10px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loading-text,
.error-text {
  font-size: 16px;
  color: #666;
  margin-bottom: 10px;
}

.error-icon {
  width: 40px;
  height: 40px;
  background-color: #f44336;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 10px;
}

.retry-btn {
  background-color: #3498db;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.3s;
}

.retry-btn:hover {
  background-color: #2980b9;
}

.map-controls {
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 100;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.control-group {
  display: flex;
  flex-direction: column;
  gap: 2px;
  background-color: white;
  border-radius: 4px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.control-btn {
  width: 36px;
  height: 36px;
  background-color: white;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 18px;
  color: #333;
  transition: background-color 0.3s;
}

.control-btn:hover {
  background-color: #f5f5f5;
}

.control-btn:active {
  background-color: #e0e0e0;
}

.reset-btn {
  background-color: white;
  border-radius: 4px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

/* 响应式调整 */
@media (max-width: 768px) {
  .map-controls {
    top: 10px;
    right: 10px;
  }
  
  .control-btn {
    width: 32px;
    height: 32px;
    font-size: 16px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/BaiduMap/BaiduMap.vue